/*
  Prefetch Service
  madeby Sun
*/
import contractsApi from '@/api/now/contractsApi'

let contractService = {
  // pending -> completed -> partially_started -> started -> canceled
  async isPending() {
    try {
      let { data } = await contractsApi.getCurrentContract()
      return data.status === 'pending'
    } catch (e) {
      console.log(e)
      return false
    }
  },
  async postAgreement(agreement) {
    return new Promise(async (resolve, reject) => {
      try {
        let res = await contractsApi.postAgreement(agreement)
        resolve(res)
      } catch (e) {
        reject(e)
      }
    }).catch(e => {
      throw e
    })
  },
  async getCurrentStatus() {
    return new Promise(async (resolve, reject) => {
      try {
        let { data } = await contractsApi.getCurrentContract()
        resolve(data)
      } catch (e) {
        reject(e)
      }
    })
  },
  async isStatusIn(...statuses) {
    try {
      const { data } = await contractsApi.getCurrentContract()
      const currentStatus = data.status
      if (!currentStatus) {
        return false
      }
      return statuses.includes(currentStatus)
    } catch (e) {
      console.log(e)
      return false
    }
  },
}

export default contractService
